import ValidationView from '@components/ValidationView.vue'
import useValidation from '@hooks/useValidation'

// пример импорта валидаторов
// import { required, helpers } from '@vuelidate/validators'
export default {
  // Пример валидации полей
  // validations() {
  //   return {
  //     formData: {
  //       alias: {
  //         required: helpers.withMessage(своё сообщение об ошибке, required),
  //       },
  //     },
  //     phone: {
  //       incorrectPhone: helpers.withMessage(
  //         'Укажите корректный номер телефона',
  //         correctPhoneNumber
  //       ),
  //     },
  //   }
  // },

  components: {
    ValidationView, // Компонент для демонстрации ошибок
  },

  setup() {
    return useValidation()
  },
}
